module.exports = __webpack_public_path__ + "img/TZS09637.3407acea.jpeg";